import { CourseViewType } from 'src/state/courseListing/courseListingReducer';

export const courseViewTypes: CourseViewType[] = [
  CourseViewType.All,
  CourseViewType.Online,
  CourseViewType.Elearning,
  CourseViewType.CourseBundle,
];

export interface CourseViewTypeInfo {
  count: number;
  courseType: CourseViewType;
  description?: string;
  id: number;
  title: string;
}

export const courseViewTypeInfoMapper: Record<CourseViewType, CourseViewTypeInfo> = {
  [CourseViewType.All]: {
    id: 0,
    title: 'Wszystkie',
    courseType: CourseViewType.All,
    count: 65,
  },
  [CourseViewType.Online]: {
    id: 1,
    title: 'Szkolenia online',
    description:
      'Odbywają się wyznaczonego dnia o określonej godzinie i prowadzone są na żywo z wykładowcą.',
    courseType: CourseViewType.Online,
    count: 28,
  },
  [CourseViewType.Elearning]: {
    id: 2,
    title: 'E-learning',
    description:
      'Nagrane szkolenie składające się z kilku modułów po 15-20 min., które dostępne jest na platformie dla wszystkich zainteresowanych bez ograniczeń czasowych.',
    courseType: CourseViewType.Elearning,
    count: 24,
  },
  [CourseViewType.CourseBundle]: {
    id: 3,
    title: 'Kursy',
    description: '',
    courseType: CourseViewType.CourseBundle,
    count: 0,
  },
};

export const initialItemsCountToDisplay = 6;

export const itemsPerPageFullSectionView = 12;
